import { render, staticRenderFns } from "./order-mobile.vue?vue&type=template&id=ccba1182"
import script from "./order-mobile.vue?vue&type=script&lang=js"
export * from "./order-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports